import { useCallback, useRef, useState } from 'react';
import { BimViewerHandle } from 'Data/interfaces/BimViewer/IBimViewerPort';

export type BimBackground = 'light' | 'dark';

// Claro é o do Figma; escuro é o fundo que o viewer tinha antes.
export const BIM_BACKGROUND_COLORS: Record<BimBackground, string> = {
  light: '#F7F7F7',
  dark: '#1A1C21',
};

const STORAGE_KEY = 'coordly3DViewerBackground';

export const readBimBackground = (): BimBackground => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

/**
 * Fundo do viewer 3D (claro/escuro), lembrado entre sessões. O motor nasce no
 * claro: `apply` é para quando o handle fica pronto, e o `color` pinta o
 * `.app-shell` para não piscar a outra cor antes do canvas.
 */
export const useBimBackground = () => {
  const [background, setBackground] = useState<BimBackground>(readBimBackground);
  const backgroundRef = useRef(background);
  backgroundRef.current = background;

  const apply = useCallback((handle: BimViewerHandle | null) => {
    handle?.setBackground(BIM_BACKGROUND_COLORS[backgroundRef.current]);
  }, []);

  const toggle = useCallback((handle: BimViewerHandle | null) => {
    const next: BimBackground = backgroundRef.current === 'light' ? 'dark' : 'light';
    setBackground(next);
    handle?.setBackground(BIM_BACKGROUND_COLORS[next]);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch { /* sem storage, a escolha vale só nesta sessão */ }
  }, []);

  return { color: BIM_BACKGROUND_COLORS[background], apply, toggle };
};
